"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOfTypeGracefulError = void 0;
const isOfTypeGracefulError = (tbd) => {
    if (tbd === null || tbd === void 0 ? void 0 : tbd.message) {
        return true;
    }
    return false;
};
exports.isOfTypeGracefulError = isOfTypeGracefulError;
//# sourceMappingURL=GracefulError.js.map